import { getAuthenticatedUser } from "@roman/shared/store/auth.store";
import { useState } from "react";
import { useEffect } from "react";
import { SMSUncertifiedRegistration } from "./components/SMSUncertifiedRegistration";
import { SMSVerifiedRegistration } from "./components/SMSVerifiedRegistration";

export const SMSRegistration = () => {
  const [statusRegistration, setStatusRegistration] = useState<"verified" | "uncertified">();

  const user = getAuthenticatedUser();

  useEffect(() => {
    if (user.isSMSVerified) {
      setStatusRegistration("verified");
    } else {
      setStatusRegistration("uncertified");
    }
  }, [user.isSMSVerified]);

  const renderRegistrationComponent = () => {
    switch (statusRegistration) {
      case "verified":
        return <SMSVerifiedRegistration />;
      case "uncertified":
        return <SMSUncertifiedRegistration />;
      default:
        return null;
    }
  };

  return <div>{renderRegistrationComponent()}</div>;
};
